export default __webpack_public_path__ + "static/media/reserved_flag.066bd78b.svg";